import dateFormat from "dateformat";

// Configuração de i18n para português brasileiro
const i18nConfig = {
    dayNames: [
        "Dom",
        "Seg",
        "Ter",
        "Qua",
        "Qui",
        "Sex",
        "Sáb",
        "Domingo",
        "Segunda",
        "Terça",
        "Quarta",
        "Quinta",
        "Sexta",
        "Sábado",
    ],
    monthNames: [
        "Jan",
        "Fev",
        "Mar",
        "Abr",
        "Mai",
        "Jun",
        "Jul",
        "Ago",
        "Set",
        "Out",
        "Nov",
        "Dez",
        "Janeiro",
        "Fevereiro",
        "Março",
        "Abril",
        "Maio",
        "Junho",
        "Julho",
        "Agosto",
        "Setembro",
        "Outubro",
        "Novembro",
        "Dezembro",
    ],
    timeNames: ["a", "p", "am", "pm", "A", "P", "AM", "PM"],
};

const instance = (date, short) => {
    if (!date || date === '--') return '--';
    
    try {
        if (short) {
            return dateFormat(date, "dd/mm/yyyy h:MM TT", i18nConfig);
        } else {
            return dateFormat(date, "dddd, d, mmmm, yyyy, h:MM:ss TT", i18nConfig);
        }
    } catch (error) {
        console.error('Erro ao formatar data:', error);
        return '--';
    }
}

export default instance;